import React, { useState } from "react";
import { Trans } from "react-i18next";

import {
  Button,
  Callout,
  Checkbox,
  Collapse,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";

import { mefDate, mefPlate } from "../../utils/mef";
import { TableCustom } from "../Structure/navbar/blueprintTableincludes";
import { parkLookup } from "../Structure/ParkSelector";
import BookingTag from "../Supervision/UserInfo/BookingTag";
import { deviceLookup } from "../Structure/EquipmentSelector";
import { BookingStateTag } from "../Supervision/UserManagement/BookingManagement";

export default function BookingList(props) {
  const [show_filters, showFilters] = useState(false);
  const [plateFilter, setPlateFilter] = useState(undefined);
  const [statusFilters, setStatusFilters] = useState([]);
  const [pincodeFilter, setPincodeFilter] = useState(undefined);

  return (
    <Callout icon="book" title={<Trans>bookings</Trans>}>
      <Button icon="filter-list" onClick={() => showFilters(!show_filters)} />
      <Collapse isOpen={show_filters}>
        <FormGroup
          label={
            <span>
              <Trans>plate</Trans>
              <Trans>:</Trans>
            </span>
          }
          labelFor="input_plate"
          inline={true}
        >
          <InputGroup
            id="input_plate"
            value={plateFilter}
            onChange={(ti) =>
              setPlateFilter(
                ti.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/g, "")
              )
            }
            maxLength="12"
            leftIcon="widget-button"
          />
        </FormGroup>

        <FormGroup
          label={
            <span>
              <Trans>Code</Trans>
              <Trans>:</Trans>
            </span>
          }
          labelFor="input_pincode"
          inline={true}
        >
          <InputGroup
            id="input_pincode"
            value={pincodeFilter}
            onChange={(ti) =>
              setPincodeFilter(
                ti.target.value.toUpperCase().replace(/[^0-9]/g, "")
              )
            }
            maxLength="12"
            leftIcon="array-numeric"
          />
        </FormGroup>

        <FormGroup label={<Trans>booking status</Trans>} inline={true}>
          {["A", "U", "P", "Q", "C", "B"].map((status) => (
            <Checkbox
              key={"cbs" + status}
              inline={true}
              value={status}
              onChange={(cb) => {
                if (cb.target.checked)
                  setStatusFilters([...statusFilters, cb.target.value]);
                else
                  setStatusFilters(statusFilters.filter((br) => br !== status));
              }}
            >
              {<BookingStateTag state={status} />}
            </Checkbox>
          ))}
        </FormGroup>
      </Collapse>

      <TableCustom
        paging={true}
        url={
          "/bookings/list?" +
          new URLSearchParams({
            srv: props.server.id,
          }) +
          (plateFilter ? "&plate=" + plateFilter : "") +
          (pincodeFilter ? "&pincode=" + pincodeFilter : "") +
          (statusFilters.length > 0
            ? "&status=" + statusFilters.join("&status=")
            : "")
        }
        orderBy="start"
        columns={[
          {
            title: <Trans>start date</Trans>,
            field: "start",
            sortable: true,
            render: (raw) => mefDate(raw.start),
          },
          {
            title: <Trans>end date</Trans>,
            field: "end",
            sortable: true,
            render: (raw) => mefDate(raw.end),
          },
          {
            title: "booker",
            field: "identity",
            sortable: true,
            render: (raw) => raw.identity,
          },
          {
            title: "Code",
            field: "pincode",
            sortable: true,
            render: (raw) => raw.pincode,
          },
          {
            title: <Trans>plate</Trans>,
            field: "plate",
            sortable: true,
            render: (raw) => mefPlate(raw.plate),
          },
          {
            title: <Trans>park</Trans>,
            sortable: true,
            field: "park",
            render: (raw) =>
              parkLookup()[props.server.id + "_" + raw?.parks[0]],
          },
          {
            title: <Trans>booking status</Trans>,
            sortable: true,
            field: "status",
            render: (raw) => <BookingStateTag state={raw.status} />,
          },
          {
            title: <Trans>info</Trans>,
            render: (raw) => (
              <BookingTag
                server={props.server.id}
                id={raw.id}
                parkLookup={parkLookup()}
                deviceLookup={deviceLookup()}
              />
            ),
          },
        ]}
      />
    </Callout>
  );
}
